module.exports = __webpack_public_path__ + "img/sponsors__cover.5ce5763c.png";